import { render, staticRenderFns } from "./BookingStart.vue?vue&type=template&id=04491528&scoped=true"
import script from "./BookingStart.vue?vue&type=script&lang=ts"
export * from "./BookingStart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04491528",
  null
  
)

export default component.exports